module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Cond.9cb54f9.woff";